import { IconButton, Paper } from "@mui/material";
import { Close } from "@mui/icons-material";
// import Textbox from "component/commonComponents/Textbox";
import Typography from "component/commonComponents/Typography";
import React, { useState } from "react";
import parse from 'html-react-parser';
import HlxButton from "../../../commonComponents/button/button";
import GeneralDialog from "../../../dialogComponents/generalDialog/generalDialog";
import { StyledEditComment } from "./editComment.style";
import CommentInput from "../commentInput/commentInput";
import { CommentValue } from "../comments.model";
import { handleKeyPress } from "utils/functions";

export interface IEditCommentProps {
  comment?: any;
  attachments: File[];
  onAttachmentChange?: (files: File[]) => void;
  handleCancelEdit?: () => void;
  submitEditComment?: (data: CommentValue, uid: string) => void;
  locale?: any;
}

const EditComment = (props: IEditCommentProps) => {
  const { comment, attachments, onAttachmentChange, handleCancelEdit, submitEditComment, locale } = props;
  const [inputVal, setInputVal] = useState<string>(comment?.comments);
  const [isOpenCancelDialog, setIsOpenCancelDialog] = useState(false);
  const [hasErr, setHasErr] = useState(false);

  const ButtonActionComment = (props: any) => {
    const { txtCancel, txtConfirm, handleCancel, handleConfirm } = props;
    return (
      <>
        <HlxButton
          variant="outlined"
          label={txtCancel}
          onClick={handleCancel}
          onKeyDown={(e: KeyboardEvent) => handleKeyPress(e, 'Enter', handleCancel)}
        />
        <HlxButton
          label={txtConfirm}
          onClick={handleConfirm}
          onKeyDown={(e: KeyboardEvent) => handleKeyPress(e, 'Enter', handleCancel)}
        />
      </>
    );
  };

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    if (event.target.value) {
      if(event.target.value.trim() !== "") {
        setHasErr(false);
      } else {
        setHasErr(true);
      }
      setInputVal(event.target.value);
    } else {
      setInputVal("");
      setHasErr(true);
    }
  };

  const handleOnKeyPress = (e: React.KeyboardEvent<HTMLInputElement>, commentVal: CommentValue, uid: string = "") => {
    const { content } = commentVal;
    if (e.key === "Enter") {
      e.preventDefault();
      if (content === parse(comment?.comments)[0]) {
        setInputVal("");
        handleCancelEdit?.();
      } else {
        if (content.trim() !== "") {
          setInputVal("");
          submitEditComment?.(commentVal, uid);
        }
      }
    }
  };

  const handleSubmitEditComment = (commentVal: CommentValue, uid: string) => {
    const { content } = commentVal;
    if (content === parse(comment?.comments)[0]) {
      setInputVal("");
      handleCancelEdit?.();
    } else {
      if (content.trim() !== "") {
        setInputVal("");
        submitEditComment?.(commentVal, uid);
      }
    }
  };

  return (
    <>
      <StyledEditComment>
        <div className="edit-comment">
          <Paper component="form" className="cmt-form">
            <IconButton
              tabIndex={0}
              aria-label="close"
              className="edit-button-close"
              onClick={() => setIsOpenCancelDialog(true)}
            >
              <Close />
            </IconButton>
            <CommentInput
              value={inputVal}
              attachments={attachments}
              attachmentConfig={{ disabled: true, canDelete: false }}
              onChange={handleChange}
              onAttachmentChange={onAttachmentChange}
              onKeyPress={(e) => handleOnKeyPress(e, { content: inputVal, attachments }, comment.uid)}
              onSubmit={(value) => handleSubmitEditComment(value, comment.uid)}
              locale={locale}
            />
            {/* <Textbox
              id="multiline-comment"
              variant="standard"
              multiline
              value={inputVal}
              onKeyPress={(e: any) => handleOnKeyPress(e, { content: inputVal, attachments }, comment.uid)}
              onChange={(event: any) => handleChange(event)}
            /> */}
            {!!hasErr && (
              <p className="captionRegular">{locale?.hintEditText}</p>
            )}
            {/* <div className="edit-comment-btn">
              <ButtonActionComment
                txtCancel={locale?.txtCancel}
                txtConfirm={locale?.txtOk}
                handleCancel={() => setIsOpenCancelDialog(true)}
                handleConfirm={() =>
                  handleSubmitEditComment({ content: inputVal, attachments }, comment.uid)
                }
              />
            </div> */}
          </Paper>
          <GeneralDialog
            headerBackgroundDefault={false}
            isOpen={isOpenCancelDialog}
            title={locale?.dialogTitle}
            content={<Typography>{locale?.dialogHeading}</Typography>}
            handleClose={() => setIsOpenCancelDialog(false)}
            buttonSubmit={
              <ButtonActionComment
                txtCancel={locale?.txtClose}
                txtConfirm={locale?.txtDiscard}
                handleCancel={() => setIsOpenCancelDialog(false)}
                handleConfirm={handleCancelEdit}
              />
            }
            hideButtonCancel={true}
          />
        </div>
      </StyledEditComment>
    </>
  );
};

export default EditComment;
